<template>
  <footer id="sticky-footer">
    <div class="footerAfter"></div>
    <div class="row my-1 p-0">
      <div class="w-100 text-center">
        <span style="font-size: 13px"
          >Copyright &copy; 2020 Xeno-Data GmbH</span
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
  methods: {
    store() {
      if (this.$route.path !== "/store") this.$router.push({ path: "/store" });
    },
    legal() {
      if (this.$route.path !== "/legal") this.$router.push({ path: "/legal" });
    },
    privacy() {
      if (this.$route.path !== "/privacy")
        this.$router.push({ path: "/privacy" });
    },
    home() {
      if (this.$route.path !== "/") this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped></style>
